var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"whatsapp-btn",style:(_vm.customStyle)},[_c('v-btn',{attrs:{"href":_vm.whatsappUrl,"target":"_blank","color":"rgba(37,211,102,1)","fab":"","x-large":"","dark":""}},[_c('v-icon',[_vm._v("mdi-whatsapp")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }